var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy"},[_c('div',{attrs:{"name":"termly-embed","data-id":"e54db78f-0498-44c2-88d8-c13ace4d629f","data-type":"iframe"}})])
}]

export { render, staticRenderFns }